var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9V5l8 7-8 7v-4H8V9h8zm-2 10v-.083A7.93 7.93 0 0110 20c-4.411 0-8-3.589-8-8s3.589-8 8-8a7.93 7.93 0 014 1.083V2.838A9.957 9.957 0 0010 2C4.478 2 0 6.477 0 12s4.478 10 10 10a9.957 9.957 0 004-.838V19z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTYgOXYtNGw4IDctOCA3di00aC04di02aDh6bS0yIDEwdi0uMDgzYy0xLjE3OC42ODUtMi41NDIgMS4wODMtNCAxLjA4My00LjQxMSAwLTgtMy41ODktOC04czMuNTg5LTggOC04YzEuNDU4IDAgMi44MjIuMzk4IDQgMS4wODN2LTIuMjQ1Yy0xLjIyNi0uNTM2LTIuNTc3LS44MzgtNC0uODM4LTUuNTIyIDAtMTAgNC40NzctMTAgMTBzNC40NzggMTAgMTAgMTBjMS40MjMgMCAyLjc3NC0uMzAyIDQtLjgzOHYtMi4xNjJ6Ii8+PC9zdmc+";
export { SvgLogout as ReactComponent };